import { Component, OnInit, inject } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { AuthenticationService } from "../../shared/services/authentication.service";
import { AccountService } from "../../api/services/account.service";
import { ModelUser } from "../../model/model.user";

@Component({
  selector: "app-modal-account-email",
  templateUrl: "./modal-account-email.component.html",
  styleUrls: ["./modal-account-email.component.scss"],
  standalone: false,
})
export class ModalAccountEmailComponent implements OnInit {
  private fb = inject(FormBuilder);
  private authService = inject(AuthenticationService);
  private accountService = inject(AccountService);
  public activeModal = inject(NgbActiveModal);

  faSpinner = faSpinner;
  isProcessing = false;
  accountProfile: ModelUser | null = null;

  emailForm = this.fb.group({
    emailAddress: ["", [Validators.required, Validators.email]],
  });

  get email() {
    return this.emailForm.get("emailAddress");
  }

  ngOnInit(): void {
    this.accountProfile = this.authService.getCurrentAccountProfileData();

    if (!this.accountProfile) {
      this.activeModal.close(false);
    }
  }

  save(): void {
    if (this.emailForm.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }

    if (!this.accountProfile) return;

    this.isProcessing = true;

    this.accountService
      .changeEmailAddress({
        id: this.accountProfile.id,
        body: { emailAddress: this.emailForm.value.emailAddress! },
      })
      .subscribe({
        next: () => {
          this.authService.handleAfterEmailChange();
          this.activeModal.close(true);
        },
        error: () => {
          this.isProcessing = false;
        },
        complete: () => {
          this.isProcessing = false;
        },
      });
  }
}
